// suporterb em rbdigital/emaissistema: no celular ele tem um menu inicial com
// todas as telas mobile e também o sistema completo (menu lateral em gaveta).
// Lista própria, menor que a do Painel de Clientes (sem o jcr). Qualquer
// outro usuário/site segue o fluxo mobile de sempre (uma tela só, definida
// pelo papel — ver GuardaMobile em App.jsx).
const HOSTS_MOBILE_COMPLETO = ['rbdigital.emaisgestor.com.br', 'emaissistema.com.br', 'rbdigital.emaissistema.com.br'];

export function hostMobileCompleto() {
  return typeof window !== 'undefined' && HOSTS_MOBILE_COMPLETO.includes(window.location.hostname);
}

export function modoMobileCompleto(usuario) {
  return !!usuario?.suporte_sistema && hostMobileCompleto();
}

const CHAVE_HUB = 'mobile_hub_visto';

export function hubMobileVisto() {
  try { return sessionStorage.getItem(CHAVE_HUB) === '1'; } catch { return true; }
}

export function marcarHubMobileVisto() {
  try { sessionStorage.setItem(CHAVE_HUB, '1'); } catch { /* sem storage: segue sem lembrar */ }
}
